import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
// import { FormattedMessage } from 'react-intl'
import { injectIntl, intlShape } from 'react-intl'

class Textbox extends PureComponent {

  constructor(props) {
    super(props)
    this.onChange = props.onChange.bind(this)
  }

  render() {
    const { intl, type, htmlId, htmlName, onChange, value, placeholder, placeholderI18n, className, disabled, valid} = this.props

    const placeholderValue = placeholderI18n 
      ? intl.formatMessage({ id: placeholderI18n, defaultMessage: placeholder || ' ' })
      : placeholder || ''

    return (
      <input
        type={type}
        id={htmlId}
        name={htmlName}
        onChange={onChange}
        value={value}
        placeholder={placeholderValue}
        className={`${className} ${disabled ? 'bg-grey-lighter' : `bg-white ${valid ? 'hover:border-grey-darkest' : 'hover:border-red bg-red-lightest'} text-grey-darkest`} ${!valid ? 'focus:border-red' : 'focus:border-grey-darkest'} focus:outline-none appearance-none border rounded-full px-4 py-3 text-sm ${!valid && 'border-red'}`}
        disabled={disabled}
      />
    )
  }
}

Textbox.propTypes = {
  htmlId: PropTypes.string.isRequired,
  htmlName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  placeholderI18n: PropTypes.string,
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
  valid: PropTypes.bool
}

Textbox.defaultProps = {
  value: "",
  className: "",
  type: "text",
  placeholder: "",
  placeholderI18n: "",
  disabled: false,
  valid: true
}

export default injectIntl(Textbox)